
export default (state = ['Top Websites', 'Story Type', 'Industry', 'Date', 'AI Results'], action) => {
    if (action.type === 'UPDATE_TOP_FILTERS') {
        return action.payload.list;
    }

    return state;
}